import { render, staticRenderFns } from "./RoutePerformance.vue?vue&type=template&id=51888fec&scoped=true"
import script from "./RoutePerformance.vue?vue&type=script&lang=js"
export * from "./RoutePerformance.vue?vue&type=script&lang=js"
import style0 from "./RoutePerformance.vue?vue&type=style&index=0&id=51888fec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51888fec",
  null
  
)

export default component.exports